import { render } from "./KanbanCard.vue?vue&type=template&id=5eb39b86&scoped=true"
import script from "./KanbanCard.vue?vue&type=script&lang=js"
export * from "./KanbanCard.vue?vue&type=script&lang=js"

import "./KanbanCard.vue?vue&type=style&index=0&id=5eb39b86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb39b86"]])

export default __exports__